import React, { Component } from 'react'
import SimpleTabs from './components/ApprovedWithdrawalTabPanel';

class ApprovedWithdrawalTab extends Component {
    render() {
        return (
            <div>
              <SimpleTabs />
            </div>
        )
    }
}
  
export default ApprovedWithdrawalTab
  